import { EvokeAction } from "react-evoke";
import { AppState } from "../../typings/AppState";
import { AppActions } from "../../typings/AppActions";
import { api } from "../../api";

const getItemReturnReasons: EvokeAction<AppState, AppActions> = async (
  store
) => {
  try {
    const returnReasons = await api.get(`item-return/reasons`);
    // console.log(" ItemDetails", returnReasons );

    await store.update(state => {
      if (returnReasons!==undefined) {
        state.reasons = returnReasons;
      }
    });
  } catch (error) {
    console.log("error", error);
  }
};

const getItemReturnDetails: EvokeAction<AppState, AppActions> = async store => {
  try {
    const itemReturnObject = await api.get(`item-return/itemReturnDetails`);
   //console.log("itemReturn",itemReturnObject)
    await store.update(state => {
      state.itemsList = itemReturnObject;
    });
  } catch (error) {
    console.log("error", error);
  }
};

export const itemReturnActions = {
    getItemReturnReasons,
    getItemReturnDetails
};
